import * as React from 'react';
import { cn } from '../../utils/cn';

const Select = ({ children, value, onValueChange, ...props }) => {
  return (
    <div className="relative" {...props}>
      {React.Children.map(children, child => {
        if (child && child.type === SelectTrigger) {
          return React.cloneElement(child, { value, onClick: () => {} });
        }
        if (child && child.type === SelectContent) {
          return React.cloneElement(child, { value, onValueChange });
        }
        return child;
      })}
    </div>
  );
};

const SelectTrigger = React.forwardRef(({ className, children, value, ...props }, ref) => {
  return (
    <button
      ref={ref}
      type="button"
      className={cn(
        'flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
});
SelectTrigger.displayName = 'SelectTrigger';

const SelectValue = ({ placeholder }) => {
  return <span className="block truncate">{placeholder}</span>;
};
SelectValue.displayName = 'SelectValue';

const SelectContent = ({ className, children, value, onValueChange, ...props }) => {
  return (
    <select
      className={cn(
        'absolute z-50 mt-1 w-full rounded-md border border-input bg-popover text-popover-foreground shadow-md focus:outline-none',
        className
      )}
      value={value}
      onChange={(e) => onValueChange && onValueChange(e.target.value)}
      {...props}
    >
      {children}
    </select>
  );
};
SelectContent.displayName = 'SelectContent';

const SelectItem = ({ className, children, value, ...props }) => {
  return (
    <option
      className={cn('relative flex w-full cursor-pointer select-none items-center rounded-sm py-1.5 px-2 text-sm outline-none', className)}
      value={value}
      {...props}
    >
      {children}
    </option>
  );
};
SelectItem.displayName = 'SelectItem';

export { Select, SelectTrigger, SelectValue, SelectContent, SelectItem };